var _defs, _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeoPanel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 126.92 104.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2c8ffe;}.cls-2{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M96.79,39.7c0,28.68-22.71,50.4-30.64,57.11a4.15,4.15,0,0,1-5.38,0C52.84,90.1,30.13,68.38,30.13,39.7a33.33,33.33,0,0,1,66.66,0Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 63.46,
    cy: 39.7,
    r: 21.36
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeoPanel);
export default __webpack_public_path__ + "static/media/GeoPanel.2c7457aa21987c28d59744a249449fa0.svg";
export { ForwardRef as ReactComponent };